import { marker } from "../constants";
import { Fields } from "../types";
import { calcSha256 } from "./calc-hash";
import { createBuffer } from "./create-buffer";

function packValues(values: Fields) {
  const result = createBuffer();

  for (let i = 0; i < values.length; ++i) {
    if (values[i]) {
      result.addInt(values[i].toString().length);
      result.addString(values[i].toString());
    } else {
      result.addInt(0);
    }
  }

  return result;
}

/**
 * Функция для хеширования подписи в формате SHA256
 *
 */
function makeHash(fields: Fields) {
  // Алгоритм хеширования Гост
  // const hash = calc(
  //   createBuffer().addString(fields.join(":")).toArray()
  // );

  // Алгоритм хеширования SHA-256
  const hash = calcSha256(createBuffer().addString(fields.join(":")).toArray());

  return hash;
}

/**
 * Создание подписи по виртуальному сертификату при подписании документов по СМС.
 */
export function makeSmsSignature(fields: Fields) {
  const fieldsClone = [...fields];

  fieldsClone[fieldsClone.length - 1] = makeHash(fieldsClone);

  const newFields = packValues(fieldsClone);

  const sign = createBuffer()
    .addString(marker)
    .addInt(newFields.nBytes())
    .merge(newFields)
    .toBase64String();

  return sign;
}
